module.exports = __webpack_public_path__ + "static/media/startLeft.61738d99.svg";